import React, { useEffect, useState } from "react";
import { SimpleDialog } from "../dialogs/SimpleDialog";
import { AdditionalREField } from "../adjustments/AdditonalREField";
import { AdditionalREType } from "common/types/common.types";
import { ComparableSummary } from "./ComparablesSummaryTable";
import _ from "lodash";
import { IconButton as IconButtonMUI } from "@mui/material";
import EditIcon from "../../assets/icons/edit.svg";
import { formatPrice } from "common/helpers/text.helpers";
import { usePricePredictions } from "../../hooks/pricePredictions.hooks";
import { StoragePriceInfo } from "./StoragePriceInfo";
import { ParkingPriceInfo } from "./ParkingPriceInfo";

interface RelatedREPriceEditDialogProps {
  comp: ComparableSummary;
  reType: AdditionalREType;
  propertyId: string;
}

export const RelatedREPriceEditDialog: React.FC<
  RelatedREPriceEditDialogProps
> = ({ comp, reType, propertyId }) => {
  const [open, setOpen] = useState(false);

  const [currentAdjustments, setCurrentAdjustments] = useState(
    comp.adjustments
  );

  const { updateRelatedREPrice, isLoading } = usePricePredictions(propertyId);

  useEffect(() => {
    setCurrentAdjustments(comp.adjustments);
  }, [comp.adjustments]);

  if (!currentAdjustments) return null;
  return (
    <>
      <IconButtonMUI onClick={() => setOpen(true)}>
        <EditIcon />
      </IconButtonMUI>
      <SimpleDialog
        title={`Redaguoti ${
          reType === AdditionalREType.Basement ? "Sandėliuko" : "Garažo"
        } kainą`}
        open={open}
        onClose={() => setOpen(false)}
        isLoading={isLoading}
        onSubmit={async () => {
          await updateRelatedREPrice(
            comp.comparable_transaction.id,
            reType,
            currentAdjustments.additional_re?.find((re) => re.type === reType)
              ?.price ?? 0
          );
          setOpen(false);
        }}
      >
        <AdditionalREField
          type={reType}
          adjustments={currentAdjustments}
          onChange={(adjustments) => {
            setCurrentAdjustments(adjustments);
          }}
        />
        {reType === AdditionalREType.Basement && (
          <StoragePriceInfo
            property={{
              lat: comp.comparable_transaction.location.lat,
              lng: comp.comparable_transaction.location.lng,
            }}
          />
        )}
        {reType === AdditionalREType.Garage && (
          <ParkingPriceInfo
            property={{
              lat: comp.comparable_transaction.location.lat,
              lng: comp.comparable_transaction.location.lng,
            }}
          />
        )}
      </SimpleDialog>
    </>
  );
};
